package uz.ferro.erp.feature.appuser.model

import kotlinx.serialization.Serializable

@Serializable
data class SalesPointDto(
    val id: String,
    val whsId: String,
    val customerIdPrefix: String,
    val customerGroupId: Long,
    val sortOrder: Int,
    val isActive: Boolean
)